import React from 'react';

export type ReservationCustomerStatusChoice = 'confirmada' | 'pendente';

export type ReservationFormClientConfirmationModalProps = {
  open: boolean;
  customerName: string;
  date: Date;
  time: string;
  hasPhone: boolean;
  isSaving: boolean;
  onClose: () => void;
  onChoose: (choice: ReservationCustomerStatusChoice) => void;
};

export default function ReservationFormClientConfirmationModal({
  open,
  customerName,
  date,
  time,
  hasPhone,
  isSaving,
  onClose,
  onChoose,
}: ReservationFormClientConfirmationModalProps) {
  if (!open) return null;

  return (
    <div className="delete-confirm-overlay" role="dialog" aria-modal="true">
      <div className="delete-confirm-modal reservation-confirmation-choice-modal">
        <div className="delete-confirm-header reservation-confirmation-choice-header">
          {!hasPhone && (
            <p className="reservation-confirmation-choice-warning">
              Para pedir confirmação no dia da reserva, é preciso informar o telefone do cliente.
            </p>
          )}
        </div>
        <div className="delete-confirm-body">
          <p>
            Você pode confirmar a reserva agora ou deixá-la pendente para pedir a confirmação do cliente no dia da reserva.
          </p>
          <div className="reservation-confirmation-choice-summary">
            <strong>{customerName || 'Cliente sem nome informado'}</strong>
            <span>
              {date.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: 'long',
                year: 'numeric'
              })}
              {time ? ` às ${time}` : ''}
            </span>
          </div>
        </div>
        <div className="delete-confirm-actions reservation-confirmation-choice-actions">
          <button
            type="button"
            className="reservation-form-btn reservation-form-btn-cancel"
            onClick={onClose}
            disabled={isSaving}
          >
            Voltar
          </button>
          <button
            type="button"
            className="reservation-form-btn reservation-form-btn-confirm-later"
            onClick={() => onChoose('pendente')}
            disabled={isSaving || !hasPhone}
            title={!hasPhone ? 'Informe o telefone do cliente para pedir confirmação no dia da reserva.' : ''}
          >
            Pedir confirmação no dia da reserva
          </button>
          <button
            type="button"
            className="reservation-form-btn reservation-form-btn-confirm-now"
            onClick={() => onChoose('confirmada')}
            disabled={isSaving}
          >
            Confirmar reserva agora
          </button>
        </div>
      </div>
    </div>
  );
}
